<template>
  <div class="navBar">
    <div class="navbar_item" v-for="(item, index) in navdata" :key="index" @click="choseNav(item)">
      <div class="icon">
        <!-- <img :src="require('../assets/images/navbar/icon0'+(item.id)+(chosedIndex==item.id?'':'_white')+'.png')" alt=""> -->
        <img v-if="iconIndex == item.id" :src="item.icon ? item.icon : ''" alt="">
        <img v-else :src="item.icon_un ? item.icon_un : ''" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconIndex: 1,
      navdata: [
        {
          id: 1,
          icon: require('@/assets/nav/保函2.png'),
          icon_un: require('@/assets/nav/保函.png')
        },
        {
          id: 2,
          icon: require('@/assets/nav/订单2.png'),
          icon_un: require('@/assets/nav/订单.png')
        },
        {
          id: 3,
          icon: require('@/assets/nav/发票2.png'),
          icon_un: require('@/assets/nav/发票.png')
        },
        {
          id: 4,
          icon: require('@/assets/nav/个人中心2.png'),
          icon_un: require('@/assets/nav/个人中心.png')
        },
      ]
    }
  },
  created() { },
  watch: {
    $route(val) {
      if (val.path == "/"|| val.path=="/selectbank"||val.path=="/pay"||val.path=="/advancePayment"||val.path=="/performance"||val.path=="/wages") {
        this.iconIndex = 1
      }
     else if (val.path == "/order" || val.path == "/orderData" || val.path == "/insurance" || val.path=="/refund") {
        this.iconIndex = 2
      }
     else if (val.path == "/invoice"||val.path=="/applyInvoice"||val.path=="/drawBill"||val.path=="/details") {
        this.iconIndex = 3
      }
      else if (val.path == "/user"||val.path == "/certification"||val.path == "/changePass") {
        this.iconIndex = 4
      }
    }
  },
  mounted() {
  },
  methods: {
    choseNav(e) {
      this.iconIndex = e.id
      if (this.iconIndex == 1) {
        this.$router.push('/')
      } else if (this.iconIndex == 2) {
        this.$router.push('/order')
      } else if (this.iconIndex == 3) {
        this.$router.push('/invoice')
      } else if (this.iconIndex == 4) {
        this.$router.push('/user')
      }
    }
  },
}
</script>

<style lang='less' scoped>
.navBar {
  height: 98px;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  z-index: 666;
  justify-content: space-around;
  align-items: center;
  background-color: #FFFFFF;
  padding: 13px 0;

  .navbar_item {
    width: 25%;
    display: flex;
    justify-content: center;

    .icon {
      width: 94px;
      height: 73px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>